import { decodeHTML } from '../../helpers';

export const prepareStringToCopy = str => decodeHTML(str).replace(/<[^>]+>/g, '').replaceAll('&amp;', '&').replaceAll('&thinsp;', ' ')
  .replaceAll('&nbsp;', '\n')
  .trim();
